import { MaskitoElement, MaskitoOptions, MaskitoPlugin, maskitoTransform, maskitoUpdateElement } from '@maskito/core';
import { maskitoEventHandler, maskitoParseNumber } from '@maskito/kit';
import { mergeFn } from '@direct-frontend/stdlib';

import { clamp, stringifyNumberWithoutExp } from '../utils';

/**
 * Плагин для валидации минимального и максимального значения
 */
export function createMinMaxPlugin({
    min,
    max,
    decimalSeparator,
}: {
    min: number;
    max: number;
    decimalSeparator: string;
}): MaskitoPlugin {
    const clampValue = (element: MaskitoElement, options: MaskitoOptions) => {
        const parsedNumber = maskitoParseNumber(element.value, decimalSeparator);

        if (Number.isNaN(parsedNumber)) {
            return;
        }

        const clampedNumber = clamp(parsedNumber, min, max);

        if (parsedNumber === clampedNumber) {
            return;
        }

        const value = maskitoTransform(stringifyNumberWithoutExp(clampedNumber), options);

        maskitoUpdateElement(element, {
            value,
            selection: [value.length, value.length],
        });
    };

    // Вызываем при инициализации и при расфокусе
    return mergeFn(clampValue, maskitoEventHandler('blur', clampValue, { capture: true }));
}
